import { PersystEEGLabelsSocketResponse } from "../Types/SocketResponse";
import { ImagePage } from "./ImagePage";
import { PersystEEGImagePage } from "./PersystEEGImagePage";
import { PersystPageManager } from "./PersystPageManager";
import { ModalityDataSource } from "../Types/ModalityDataSource";
import { ImagePageManagerConfig } from "./ImageTimeSeriesPageManager";

export type PersystEEGPageManagerConfig = ImagePageManagerConfig & {
	LFF: number
	HFF: number
	notch: number
	sensitivityMicrovolts: number
	isArtifactReductionEnabled: boolean
}

export class PersystEEGImagePageManager extends PersystPageManager<PersystEEGPageManagerConfig> {
	getPageMaker = () => {
		return () => new PersystEEGImagePage()
	}

    protected getNewPage(startTime: number, endTime: number, width: number, height: number, patientId: string, modalityDataSources: ModalityDataSource[], socketId: string, patientIsAdmitted: boolean): ImagePage {
        const page = new PersystEEGImagePage()

		page.updateProperties({ 
			startTime, 
			endTime, 
			width, 
			height, 
			patientId, 
			modalityDataSources, 
			socketId, 
			patientIsAdmitted,
			maxReadTime: this.config.fileScale.domain()[1].getTime(),
			recordingStartTime: this.config.fileScale.domain()[0].getTime(),
			getDataQuerySocket: this.getDataQuerySocket,
			LFF: this.config.LFF,
			HFF: this.config.HFF,
			notch: this.config.notch,
			sensitivityMicrovolts: this.config.sensitivityMicrovolts,
			isArtifactReductionEnabled: this.config.isArtifactReductionEnabled
		})

		return page
    }

	protected updatePageProperties(page: PersystEEGImagePage, startTime: number, endTime: number, width: number): void {
		page.updateProperties({
			startTime,
			endTime,
			width,
			socketId: this.config.windowId,
			patientId: this.config.patientId,
			modalityDataSources: this.config.modalityDataSources,
			patientIsAdmitted: this.config.patientIsAdmitted,
			height: this.config.height,
			maxReadTime: this.config.fileScale.domain()[1].getTime(),
			recordingStartTime: this.config.fileScale.domain()[0].getTime(),
			getDataQuerySocket: this.getDataQuerySocket,
			LFF: this.config.LFF,
			HFF: this.config.HFF,
			notch: this.config.notch,
			sensitivityMicrovolts: this.config.sensitivityMicrovolts,
			isArtifactReductionEnabled: this.config.isArtifactReductionEnabled,
		})
	}

	protected requestTitlesAndLabels = (height: number, width: number, montage: string) => {
		this.setRequestDimensions({ height, width, panel: montage })
		const eventName = "render_persyst_eeg_labels"

		if (this.getDataQuerySocket === null) {
			return
		}
		
		const socket = this.getDataQuerySocket(this.config.windowId)

		const listener = (event: PersystEEGLabelsSocketResponse) => {
			if (event.height !== height || event.width !== width) {
				socket.off(eventName, listener)
				return
			}

			const data = {
				titles: new ArrayBuffer(0),
				labels: event.image,
			}

			this.setTitlesAndLabelsCache({
				panel: montage,
				dimensions: { height, width },
				data: data,
			})

			socket.off(eventName, listener)
			this.setRequestDimensions(null)
			this.onTitlesAndLabelsLoaded()
		}

		socket.on(eventName, listener)
		socket.emit(eventName, this.config.patientId, this.config.modalityDataSources[0].dataObjectId, 1, montage, width, height)
	}
}
